import React from 'react';

interface StepIndicatorProps {
    currentStep: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => {
    return (
        <div className="step-indicator">
            <div className={`step ${currentStep === 1 ? 'active' : currentStep > 1 ? 'completed' : 'inactive'}`}>
                1
            </div>
            <div className={`step ${currentStep === 2 ? 'active' : 'inactive'}`}>
                2
            </div>
        </div>
    );
};

export default StepIndicator;